







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class TooManyRequestedError extends Vue {
  @Prop({ default: 'p' })
  readonly tag: string
}
